module.exports = __webpack_public_path__ + "img/meme_22.aacb3b3f.jpg";